/* Global imports. */
import React from "react";
import { ImageElement } from "@kontent-ai/gatsby-components";
import { convertKontentImageURLToImageKitURL, cleanImagePathForImageKit } from "../../imagekit";
interface Props {
  title: string;
  description: string;
  resource: {
    url: string;
  };
  image: {
    name: string;
    url: string;
    width?: number
    height?: number
  };
  buttonText: string;
  hasKeyline: boolean;
  referringSlug?: string;
}

const Download = ({ title, description, resource, image, buttonText, hasKeyline, referringSlug }: Props) => {

    const imageKitURL = image && image.url ? convertKontentImageURLToImageKitURL(cleanImagePathForImageKit(image.url)) : null

    return (
        <div className={`flex flex-col my-8 ${hasKeyline ? "shadow-2xl rounded-md" : "" }`}>
            <figure className={`max-w-xs mx-auto mb-3`}><div className="p-3 mb-3 border border-gray-200 border-solid rounded-md">
            {image && image.url && <img src={imageKitURL} alt={image.name ? image.name : ""} width="300" height={image.height} />}
            </div>
            {title && <h5 className="px-4 mb-3 font-serif text-center">{title}</h5>}
            {description && <p className="font-sans text-sm text-center">{description}</p>}
            </figure>
        
            <a href={resource.url} data-ref-slug={referringSlug} data-resource-title={title} className="mb-8 button">
            {buttonText}
            </a>
        </div>
    )
};

export default Download;
